import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, effect, inject,HostListener   } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ShareDataService } from '../../shared/utils/share-data.service';
import { RoleService } from '../../services/role/role.service';
import { ToggleService } from '../../services/toggle-service/toggle-service.service';
import { AuthService } from '../../services/auth/auth.service';
import { NotificationService } from '../../shared/utils/notification.service';
import { LoaderService } from '../../services/loader/loader.service';
import { DashboardLandingComponent } from './masters/landing-dashboard-page/dashboard_landing';
import { HeaderShowHideService } from '../../shared/utils/headerShowHide.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, NgFor, NgClass, NgIf,DashboardLandingComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.componen.scss',
})
export class HomeComponent  {
  selectedMenu: string | null = null;

  toggleMenu(event: Event, menuLabel: string): void {
    event.preventDefault();
    if (this.selectedMenu === menuLabel) {
      this.selectedMenu = null;
    } else {
      this.selectedMenu = menuLabel;
    }
  }
  selectedParentIndex: number = 0;  // Initialize with first module selected
  toggleService = inject(ToggleService);
  isToggled: boolean = false;
  title:any;
  shareDataService = inject(ShareDataService)
  authService = inject(AuthService)
  roleService = inject(RoleService)
  loadingService = inject(LoaderService)
  headerService = inject(HeaderShowHideService);
  router = inject(Router);
  notificationService = inject(NotificationService)
  login_timeout_ref: any;

  constructor() { 
   this.title = this.shareDataService.getData(); 
   this.toggleService.isToggled$.subscribe((status) => {
    this.isToggled = status;
  });
  }

  ngOnInit(): void {
    this.headerService.display(true)
    this.constant_login_check()
  }

  menuItems: any[] = [
    { id: 1, label: 'DASHBOARD',name:'Dashboard', accessUrl: 'dashboard', route: '/dashboard', },
    { 
      id: 2, 
      label: 'MASTERS', 
      name:'Masters',
      accessUrl: 'masters',
      subGroups: [
        {
          label: 'Geographical Area Master',
          items: [
            { label: 'GA Master', accessUrl: 'masters/ga-master', route: '/masters/ga-master' },
            { label: 'Business Area Master', accessUrl: 'masters/business-area-master', route: '/masters/business-area-master' },
            { label: 'Station Master', accessUrl: 'masters/station-master', route: '/masters/station-master' },
          ]
        },
        {
          label: 'Ownership & Entity Master',
          items: [
            { label: 'Ownership Master', accessUrl: 'masters/ownership-master', route: '/masters/ownership-master' },
            { label: 'CNG Customer', accessUrl: 'masters/cng-customer-master', route: '/masters/cng-customer-master' }
          ]
        },
        {
          label: 'Equipment Master',
          items: [
            { label: 'Compressor Master', accessUrl: 'masters/compressor-master', route: '/masters/compressor-master' },
            { label: 'Dispenser Master', accessUrl: 'masters/dispenser-master',  route: '/masters/dispenser-master' },
            { label: 'Electricity Meter Master', accessUrl: 'masters/electricity-meter-master',  route: '/masters/electricity-meter-master' },
            { label: 'Cascade Master', accessUrl: 'masters/cascade-master',  route: '/masters/cascade-master' },
          ]
        },
        {
          label: 'Operations Master',
          items: [
            { label: 'FCM Master', accessUrl: 'masters/fcm-master', route: '/masters/fcm-master' },
            { label: 'Collection Mode Master', accessUrl: 'masters/collection-mode-master',  route: '/masters/collection-mode-master' },
            { label: 'Slab Master', accessUrl: 'masters/slap-master',  route: '/masters/slap-master' },
            { label: 'CBG Producer', accessUrl: 'masters/cbg-customer-master', route: '/masters/cbg-customer-master' },
          ]
        },
        {
          label: 'Logistics & Fleet Master',
          items: [
            { label: 'Vehicle Master', accessUrl: 'masters/vehicle-master',  route: '/masters/vehicle-master' },
          ]
        },
        {
          label: 'System Configuration Master',
          items: [
            { label: 'Flag Master', accessUrl: 'masters/flag-master',  route: '/masters/flag-master' },
            { label: 'User Master', accessUrl: 'masters/user-master',  route: '/masters/user-master' },
            { label: 'Contact Details', accessUrl: 'masters/contact-details',  route: '/masters/contact-details' },
          ]
        }
      ]
    },
    { 
      id: 3, 
      label: 'Transaction', 
      name:'Transactions',
      accessUrl: 'transactions',
      subGroups: [
        {
          label: 'Vehicle & Cascade Operation',
          items: [
            { label: 'Vehicle Reporting Record', accessUrl: 'transaction/vehicle-reporting-register',  route: '/transaction/vehicle-reporting-register' },
            { label: 'Mobile Cascade (LCV/HCV) Filling Record', accessUrl: 'transaction/lcv-filling-entry', route: '/transaction/lcv-filling-entry' },
            { label: 'Mobile Cascade (LCV/HCV) Filling-Multi Station Record', accessUrl: 'transaction/lcv-filling-multi-station-entry', route: '/transaction/lcv-filling-multi-station-entry' },
          ]
        },
        {
          label: 'Dispenser Operation',
          items: [
            { label: 'Dispenser Sales Record', accessUrl: 'transaction/cng-sales-entry',  route: '/transaction/cng-sales-entry' },
            { label: 'Testing - Dispenser Stock Transfer', accessUrl: 'transaction/testing-dispenser-stock-transfer',  route: '/transaction/testing-dispenser-stock-transfer' },
            { label: 'Testing - Dispenser Domestic Sale', accessUrl: 'transaction/testing-dispenser-domestic-sale',  route: '/transaction/testing-dispenser-domestic-sale' },
            { label: 'Dispenser Totalizer Jumping', accessUrl: 'transaction/dispenser-totalizer-jumping',  route: '/transaction/dispenser-totalizer-jumping' },
            { label: 'Dispenser Rate Meter Change', accessUrl: 'transaction/dispenser-rate-meter-change',  route: '/transaction/dispenser-rate-meter-change' },
          ]
        },
        {
          label: 'Station Operation',
          items: [
            { label: 'Compressor Reading Record', accessUrl: 'transaction/compressor-reading-entry',  route: '/transaction/compressor-reading-entry' },
            { label: 'Electricity Reading Record', accessUrl: 'transaction/electricity-reading-entry',  route: '/transaction/electricity-reading-entry' },
            { label: 'Gas Parameters Record', accessUrl: 'transaction/gas-parameter-entry',  route: '/transaction/gas-parameter-entry' },
            { label: 'CBG Receipt Record', accessUrl: 'transaction/cbg-receipt-record',  route: '/transaction/cbg-receipt-record' }
          ]
        },
        {
          label: 'Commercial & Finance',
          items: [
            { label: 'Sales Collection Record', accessUrl: 'transaction/sales-collection-entry',  route: '/transaction/sales-collection-entry' },
          ]
        }
      ]
    },
     {
      id: 4, 
      label: 'Finance',
      name:'Finances',
      accessUrl: 'finance',
      subGroups: [
        {
          label: 'Finance Reports',
          items: [
                   { id: 1, label: 'PRICE UPDATE', name:'Price Update', accessUrl: 'finance/price-update', route: '/finance/price-update' },
                   { id: 2, label: 'DEPOSIT ENTRY', name:'Deposit Entry', accessUrl: 'finance/desposit-entry', route: '/finance/desposit-entry' },
          ]
        }
      ]
    },
     {
      id: 5, 
      label: 'Delivery Challan',
      name:'Delivery Challan',
      accessUrl: 'deliverychallan',
      subGroups: [
        {
          label: 'Delivery Challan',
          items: [
                  { id: 6, label: 'Delivery Challan',name:'Delivery Challan', accessUrl: 'deliverychallan', route: '/deliverychallan' }
          ]
        }
      ]
    },
        {
      id: 6, 
      label: 'Reports',
      name:'Reports',
      accessUrl: 'reports',
      subGroups: [
        {
          label: 'Sales & Distribution Reports',
          items: [
            { label: 'Dispenser Sale Summary Report', accessUrl: 'reports/sales-summary-reports',  route: '/reports/sales-summary-reports' },
            { label: 'LCV Filling Summary Reports', accessUrl: 'reports/lcv-filling-summary-reports',  route: '/reports/lcv-filling-summary-reports' },
            { label: 'Mother Station Output Report', accessUrl: 'reports/sales-summary-station-output',  route: '/reports/sales-summary-station-output' },
            { label: 'Daily Sales Report', accessUrl: 'reports/daily-sales-report', route: '/reports/daily-sales-report' },
            { label: 'LCV Report', accessUrl: 'reports/lcv-point-dpr', route: '/reports/lcv-point-dpr' },
            { label: 'Cumulative CBG Receipt Report',accessUrl: 'reports/cbg-receipt', route: '/reports/cbg-receipt' },
            { label: 'Day Wise CBG Receipt Report',accessUrl: 'reports/day-wise-cbg-receipt-report', route: '/reports/day-wise-cbg-receipt-report' },
            { label: 'GA Wise Sale Report', accessUrl: 'reports/ga-wise-sale-report', route: '/reports/ga-wise-sale-report' },
            { label: 'GA Wise Status Report', accessUrl: 'reports/ga-wise-status-report', route: '/reports/ga-wise-status-report' },
          ]
        },
        {
          label: 'Reconciliation & Efficiency Reports',
          items: [
            { label: 'Station Quantity Reconciliation', accessUrl: 'reports/quantity-reconciliation',  route: '/reports/quantity-reconciliation' },
            { label: 'Compressor Efficiency & Reconciliation Report', accessUrl: 'reports/quantity-reconciliation-compressor',  route: '/reports/quantity-reconciliation-compressor' },
            { label: 'SAP_Station Reconciliation Report', accessUrl: 'reports/sap-station-reconciliation',  route: '/reports/sap-station-reconciliation' },
          ]
        },
        {
          label: 'Financial & Collection Reports',
          items: [
            { label: 'Collection Vs Deposit', accessUrl: 'reports/collection-vs-deposit',  route: '/reports/collection-vs-deposit' },
            { label: 'Deposit Report', accessUrl: 'reports/deposit-report',  route: '/reports/deposit-report' },
            { label: 'Collection Report', accessUrl: 'reports/collection-report',  route: '/reports/collection-report' },
            { label: 'Export for Billing in SAP', accessUrl: 'reports/export-for-billing',  route: '/reports/export-for-billing' },
            { label: 'Excise Duty Report', accessUrl: 'reports/excise-duty-report',  route: '/reports/excise-duty-report' },
          ]
        },
        {
          label: 'Joint Ticket Reports',
          items: [
            { label: 'Joint Ticket OMC/COCO/DODO', accessUrl: 'reports/joint-ticket-omc', route: '/reports/joint-ticket-omc' },
            { label: 'Joint Ticket-F DODO', accessUrl: 'reports/joint-ticket-cipl', route: '/reports/joint-ticket-cipl' },
            { label: 'Joint Ticket-StockTransfer', accessUrl: 'reports/joint-ticket-stocktransfer', route: '/reports/joint-ticket-stocktransfer' },
            { label: 'Joint Ticket-Compression', accessUrl: 'reports/joint-ticket-compression', route: '/reports/joint-ticket-compression' },
            
          ]
        }
      ]
    },
  ];

  isScrolled = false;

  // Listen to the window scroll event
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    
    if (scrollPosition > 50) { // You can adjust the scroll position threshold
      this.isScrolled = true;
    } else {
      this.isScrolled = false;
    }
  }

constant_login_check() {
  this.login_timeout_ref = setInterval(() => {
    this.loadingService.ignore_loading = true;
    this.authService.userLoginVerify({}).subscribe((res: any) => {
      if (res.code != 200) {
          this.authService.logout();
          this.router.navigate(['/login']);
          this.notificationService.notification(
         'danger', 'User logged in from another device. Please login again.',
            '',
            null
          );
      } else {
        if (res.new_token) {
          let old_json_token:any = localStorage.getItem('authUser');
          if (old_json_token) {
            old_json_token = JSON.parse(old_json_token);
            old_json_token.token = res.new_token;
            localStorage.setItem('authUser', JSON.stringify(old_json_token));
          }
        }
      }
    });
  }, 15000);
}

  ngOnDestroy() {
    if (this.login_timeout_ref) {
      clearInterval(this.login_timeout_ref);
    }
  }
}
